import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AccountActivationDialogComponent } from './account-activation-dialog/account-activation-dialog.component';
import { SharedModule } from '../../../shared/shared.module';
import { AuthService } from '../../../services/auth.service';

@Component({
  standalone: true,
  selector: 'app-account-activation-page',
  template: '',
  imports: [SharedModule]
})
export class AccountActivationPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.softDisconnect();
    const code = this.route.snapshot.queryParamMap.get('code');
    const email = this.route.snapshot.queryParamMap.get('email');

    this.dialog.open(AccountActivationDialogComponent, {
      data: { verificationCode: code, email },
      disableClose: true,
      width: '700px',
      // Responsive: shrink to the viewport on small screens (scoped to this dialog only).
      maxWidth: '95vw',
      maxHeight: '95vh'
    });
  }
}
